module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-about-us",
    attrs: {
      "id": "top"
    }
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('VueTrigger', {
    attrs: {
      "function1": _vm.navScrolled,
      "function2": _vm.notScrolled
    }
  }), _c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _vm._m(0), _c('div', {
    staticClass: "pages-about-us__doctor"
  }, [_c('div', {
    staticClass: "pages-about-us__doctor--left"
  }, [_c('ImgBox', {
    attrs: {
      "props": _vm.props.acf.doctor.image
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__doctor--right"
  }, [_c('div', {
    staticClass: "pages-about-us__doctor--right--title"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.header1.title
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__doctor--right--image"
  }, [_c('ImgBox', {
    attrs: {
      "props": _vm.props.acf.doctor.image
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__doctor--right--body"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.doctor.body1
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__doctor--right--header"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.cert.header2
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__doctor--right--body"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.cert.body2
    }
  })], 1)])]), _c('div', {
    staticClass: "pages-about-us__cert"
  }, [_c('div', {
    staticClass: "pages-about-us__cert--left"
  }, [_c('div', {
    staticClass: "pages-about-us__cert--left--header"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.doctor.header3
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--left--body"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.doctor.body3
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--left--header"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.doctor.header2
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--left--body"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.doctor.body2
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--left--button"
  }, [_c('FunctionButton', {
    attrs: {
      "function1": _vm.openModal,
      "content": _vm.props.acf.cert.button
    }
  })], 1)]), _c('div', {
    staticClass: "pages-about-us__cert--right"
  }, [_c('div', {
    staticClass: "pages-about-us__cert--right--tagline"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.cert.tagline
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--right--image"
  }, [_c('ImgBox', {
    staticStyle: {
      "background-size": "contain"
    },
    attrs: {
      "props": _vm.props.acf.cert.image
    }
  })], 1), _c('div', {
    staticClass: "pages-about-us__cert--right--maglogo"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.acf.cert.ofm_logo
    }
  })]), _c('div', {
    staticClass: "pages-about-us__cert--right--magtext"
  }, [_c('TextBox', {
    attrs: {
      "props": _vm.props.acf.cert.ofm_text
    }
  })], 1)])]), _vm._m(1), _c('ContactSection', {
    staticClass: "pages-about-us__contact",
    attrs: {
      "props": _vm.props.acf.contact_page
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--title"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "body",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--body"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "address",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--address"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "subtitle",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--subtitle"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "hours",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--hours"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }, {
      key: "map",
      fn: function(props) {
        return _c('div', {
          staticClass: "pages-about-us--map"
        }, [_c('TextBox', {
          attrs: {
            "props": props.content
          }
        })], 1)
      }
    }], null, false, 3733987913)
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-about-us__videos"
  }, [_c('div', {
    staticClass: "pages-about-us__videos--left"
  }, [_c('iframe', {
    staticClass: "pages-about-us__iframe-video",
    attrs: {
      "src": "https://www.youtube.com/embed/r0NXHLSLfAk",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; playsinline; muted; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen"
    }
  })]), _c('div', {
    staticClass: "pages-about-us__videos--right"
  }, [_c('iframe', {
    staticClass: "pages-about-us__iframe-video",
    attrs: {
      "src": "https://www.youtube.com/embed/XVFTQMfncR4",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; playsinline; muted; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "panowalks1"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "https://www.panowalks.com/embed/ywhESQ5YOEDxCdKz3lmudCFXKVlj/",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "frameborder": "0",
      "allow": "autoplay; fullscreen"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af70aaa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/about-us/about-us.pug
// module id = 591
// module chunks = 1